/* eslint-disable import/prefer-default-export */
import { ResourceMap, ResourceOptionsV2 } from 'medialoopster/rest';

import { RootState } from '../../types/rootState';
import { ProjectAsset } from './types';

// TODO: Remove. Note needed for <AssetLinks/> <PB 2024-04-08 t:ML-2034>
export const getProjectAssets = (state: RootState): ResourceMap<ProjectAsset, ResourceOptionsV2> =>
  state.project.assets;
